import { render } from "./CopyText.vue?vue&type=template&id=6d2ed572&scoped=true"
import script from "./CopyText.vue?vue&type=script&lang=js"
export * from "./CopyText.vue?vue&type=script&lang=js"

import "./CopyText.vue?vue&type=style&index=0&id=6d2ed572&scoped=true&lang=css"

import exportComponent from "/home/runner/work/channel-xyz/channel-xyz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d2ed572"],['__file',"src/components/CopyText.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6d2ed572"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6d2ed572', __exports__)) {
    api.reload('6d2ed572', __exports__)
  }
  
  module.hot.accept("./CopyText.vue?vue&type=template&id=6d2ed572&scoped=true", () => {
    api.rerender('6d2ed572', render)
  })

}


export default __exports__